import {h, Component} from 'preact';
import style from './style.scss';
import ArrowLeft from '/chat/src/components/SVGImages/ArrowLeft'

class SelectInput extends Component {
    constructor(props){
        super(props)
        this.state = {
            select: props.select,
        }
        this.onChange = this.onChange.bind(this)
    }

    componentDidUpdate(prevProps){
        if(this.props.select !== prevProps.select){
            this.setState({
                select: this.props.select
            })
        }
    }

    onChange(e){
        e.target.name = this.props.name
        this.props.onChange(e)
        this.setState({
            select: e.target.value
        })
    }
    _renderList(values){
        var selects = []
        for(var value in values){
            selects.push(<option value={value} key={value}> {values[value]} </option>)
        }
        return selects
    }

    render() {
        const {label, values, isValidate, ...rest} = this.props
        return(
            <div className={style.SelectWrapper+ ' '+this.props.className} width={this.props.width} shrink={0}>
                <select value={this.state.select} onChange={this.onChange} disabled={this.props.disabled} {...rest}
                    style = {!isValidate &&  {
                        border: '2px solid #ff6d67'
                    }}
                    >
                    <option value="" selected disabled hidden>{label}</option>
                    {this._renderList(values)}
                </select>
            </div>
        );
    }
}
export default SelectInput;



// WEBPACK FOOTER //
// ./components/Forms/SelectInput/index.js